<template>
  <v-container>
    <el-container v-loading.fullscreen.lock="loading">
      <el-header height="auto">
        <el-row type="flex" align="middle">
          <el-col>
            <el-form size="small" inline>
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="reload">搜索</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="el-icon-plus" @click="add">新增图标分类</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-header>
      <el-main>
        <el-table :data="list" :row-class-name="tableRowClassName">
          <el-table-column prop="sort" label="排序" width="100" align="center"></el-table-column>
          <el-table-column prop="name" label="名称" min-width="260" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="updatedDate" label="更新时间" min-width="180" align="center" :formatter="row => $date.format('yyyy-MM-dd hh:mm:ss', row.createdDate)"></el-table-column>
          <el-table-column prop="deleted" label="状态" width="140" align="center" :formatter="row => DEL_STATUS.get(row.deleted)"></el-table-column>
          <el-table-column label="操作" width="140" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="edit(scope.row)">编辑</el-button>
              <el-button v-if="scope.row.deleted === 0" type="text" size="small" @click="del(scope.row)">删除</el-button>
              <el-button v-else-if="scope.row.deleted === 1" type="text" size="small" @click="undel(scope.row)">撤销删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer height="40px">
        <el-row type="flex" align="middle" justify="center">
          <el-pagination :current-page="page"  :total="total" :page-size="size" layout="slot, prev, pager, next, jumper" @current-change="handleCurrentChange">
            <span>
              共<span class="total">{{total}}</span>条
            </span>
          </el-pagination>
        </el-row>
      </el-footer>
    </el-container>
    <v-edit-dialog :visible="editDialogVisible" :item="item" @close="editDialogVisible = false" @update="reload"></v-edit-dialog>
  </v-container>
</template>

<script>

import MainLayout from '@/components/layout/main-header_main_footer'
import EditDialog from './edit-dialog'
import { GET_ICON_CATEGORIES, DEL_ICON_CATEGORIES, POST_ICON_CATEGORIES_UNDELETE } from '@/utils/api'
import { DEL_STATUS } from '@/utils/global-constant'

export default {
  name: 'IconCategoryList',

  components: {
    'v-container': MainLayout,
    'v-edit-dialog': EditDialog
  },

  data () {
    return {
      DEL_STATUS,
      page: 1,
      size: 20,
      total: 0,
      loading: false,
      editDialogVisible: false,
      item: {},
      list: [],
    }
  },

  watch: {
    size () {
      this.page = 1
    },

    page () {
      this.getList()
    },

    total (value) {
      if (value < (this.page - 1) * this.size) {
        this.page = 1
      }
    }
  },

  created () {
    this.getList()
  },

  methods: {
    // 获取应用列表
    getList () {
      const data = {
        size: this.size,
        page: this.page
      }
      this.loading = true
      GET_ICON_CATEGORIES(data).then(r => {
        if (r && r.status === 200) {
          this.total = r.data.total
          this.list = r.data.list
        }
        this.loading = false
      })
    },

    // 列表类名
    tableRowClassName({row, rowIndex}) {
      return rowIndex%2 === 1 ? 'warning-row' : 'success-row'
    },

    // 页面切换
    handleCurrentChange (page) {
      this.page = page
    },

    // 新增事件
    add () {
      this.item = {}
      this.editDialogVisible = true
    },

    // 编辑事件
    edit (row) {
      this.item = row
      this.editDialogVisible = true
    },

    // 删除事件
    del (row) {
      this.$confirm('确定删除该分类?', '操作确认', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        customClass: 'confirm-box'
      }).then(() => {
        DEL_ICON_CATEGORIES(row.id).then(r => {
          if (r && r.status === 200) {
            this.reload()
          }
        })
      }).catch(() => {})
    },

    undel ({ id }) {
      this.$confirm('确定恢复该分类?', '操作确认', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        customClass: 'confirm-box'
      }).then(() => {
        POST_ICON_CATEGORIES_UNDELETE(id).then(r => {
          if (r && r.status === 200) {
            this.reload()
          }
        })
      }).catch(() => {})
    },

    isNeedPageDown () {
      return new Promise((resolve, reject) => {
        const page = this.page
        while (this.total <= (this.page - 1) * this.size) {
          this.page--
        }
        page < this.page ? resolve() : reject()
      })
    },

    // 重载
    reload () {
      this.editDialogVisible = false
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.el-header {
  background-color: #ffffff;
  padding: 20px;
  padding-bottom: 0;
}
</style>
